/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Payment_Bill_MissingInputs */

const vi_grower_payment_bill_missing = /** @type {(inputs: Grower_Payment_Bill_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiếu bill`)
};

/**

* @param {Grower_Payment_Bill_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_payment_bill_missing = /** @type {((inputs?: Grower_Payment_Bill_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Payment_Bill_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_payment_bill_missing(inputs)
});